import {Component, Injectable} from '@angular/core';
import {NavController, Platform, LoadingController} from 'ionic-angular';
import {B2dProvider} from "../../providers/b2d/b2d";
import {ConfigService} from "../../app/config.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Subscription} from 'rxjs';
import {_throw as throwError} from 'rxjs/observable/throw';
import {ActivatedRoute} from "@angular/router";
import {VariablesGlobales} from '../../app/variablesGlobales';


const options = {
    headers: new HttpHeaders({
        "Access-Control-Allow-Origin": "*",
    }),
    responseType: 'text',
};

@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})

@Injectable()
export class HomePage {

    private datas;
    public currentStep;
    public config;
    public tests = [];
    public showLoading = false;
    public loadingPercent = 0;
    public loadingPercentMax = 100;
    public color;
    public language;
    interval;
    // public stepLength = 1;

    public w = {
        home_intro: "Let's do some  basic tests."
    };

    constructor(public navCtrl: NavController, platform: Platform, private b2dProvider: B2dProvider, private configService: ConfigService, private http: HttpClient, private route: ActivatedRoute, private param: VariablesGlobales, public loadingCtrl: LoadingController) {
        if (platform.isLandscape()) {
            alert('Please turn your device in Portrait mode');

        }
        if (this.route.snapshot.queryParamMap.get("apikey") == null || this.route.snapshot.queryParamMap.get("callback_url") == null || this.route.snapshot.queryParamMap.get("ticket") == null) {
            this.datas = {};
            this.navCtrl.setRoot('UnauthorizedHomePage');
        } else {
            if (param.apiKey === null || param.ticket === null || param.callback_url === null) {
                param.apiKey = this.route.snapshot.queryParamMap.get("apikey");
                param.ticket = this.route.snapshot.queryParamMap.get("ticket");
                param.callback_url = this.route.snapshot.queryParamMap.get("callback_url");

            }
            //this.getConfig(param.apiKey);
            this.configService.getConfig(param.apiKey).subscribe(data => {
                    this.configService.config = data;
                    this.color = this.configService.config['color1'];
                    this.language=this.configService.config['language'];
                    this.config = data;
                    this.tests = [];

                    //this.tests = this.config.test;
                    // console.log(this.config.test);
                    this.config.test.forEach(test => {
                        if (test.enabled) {
                            test.page = test.name.charAt(0).toUpperCase() + test.name.slice(1) + "TestPage";
                            this.tests.push(test);
                        }

                    });
                    this.tests.push({name:'question',page:'QuestionTestPage',enabled:true});
                    console.log(this.tests);
                    //console.log('home',this.configService.getCurrentStep());
                    this.gotoNextStep();
                    // this.navCtrl.setRoot('TouchTestPage');
                },
                err => {
                    this.navCtrl.setRoot('UnauthorizedHomePage');
                },
                () => {
                    // console.log('HTTP request completed.');
                });

            // console.log("config : " + JSON.stringify(this.currentStep));
        }
        this.datas = this.b2dProvider.getStoredDatas();
    }

    startTimer() {
        this.interval = setInterval(() => {
            this.loadingPercent++;
            if (this.loadingPercent >= 100) {
                this.loadingPercent = 100;
                clearInterval(this.interval);
            }
        }, 100)
    }


    gotoNextStep() {
        this.currentStep = this.configService.getCurrentStep();
        // console.log('test '+this.currentStep+' / '+this.tests.length);
        // console.log(this.tests);
        if (this.tests && this.tests.length > 0 && this.currentStep > this.tests.length) {
            this.getQuote();
        } else {
            var nextPage = this.tests[this.currentStep - 1].page;
            this.navCtrl.setRoot(nextPage);
        }

    }

    gotoPage(page, step) {
        this.configService.setCurrentStep(step);
        this.navCtrl.setRoot(page);
    }

    getQuote() {
        this.showLoading = true;
        this.startTimer();
        this.createTicket();
    }

    public createTicket(): Subscription {
        this.datas = this.b2dProvider.getStoredDatas();

        // const result = JSON.parse(JSON.stringify({...this.datas, ...this.config}));
        let data = new FormData();

        if (typeof this.b2dProvider.getStoredDatas()["picture"] !== 'undefined') {
            data.append('picture', this.b2dProvider.getStoredDatas()["picture"]);
        } else {
            data.append('picture', null);
        }

        let touchResult = (this.b2dProvider.getStoredDatas()['touch'] == undefined) ? false : this.b2dProvider.getStoredDatas()['touch'];
        data.append('touch', touchResult);

        //console.log('callback',this.configService.getApiUrl() + "ticket/new?apikey=" + this.param.apiKey + "&ticket=" + this.param.ticket + "&callback_url=" + this.param.callback_url);
        return this.http.post(this.configService.getApiUrl() + "ticket/new?apikey=" + this.param.apiKey + "&ticket=" + this.param.ticket + "&callback_url=" + this.param.callback_url, data)
            .subscribe((val) => {
                    let newUrl = this.param.callback_url + '?ticket=' + this.param.ticket + '&model=' + val['model'] + '&manufacturer=' + val['manufacturer'] + '&touchscreen='+ (val['tests']['touch']=='true'?1:0) + '&bak2Id=' + val['bak2Id'];
                    window.location.href = newUrl;
                },
                response => {
                    console.log("POST call in error", response);

                },
                () => {
                    // console.log("The POST observable is now completed.");

                });
    }

    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        alert(errorMessage);
        console.log(errorMessage);
        return throwError(errorMessage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts